import ConnectionManager from 'ConnectionManager';
import ToastManager from 'ToastManager';
import { logNewrelicAddPageAction } from '../cookies/NewRelic';
import gtmService from '../utils/gtm/gtmService';
import { httpErrorCodes } from '../utils/gtm/constants';

const showConnectionError = (message) => {
  const errorMessage = 'There was a problem communicating with our servers. Try again soon';
  gtmService.pushPageViewEvent({
    errorCode: httpErrorCodes.SERVICE_UNAVAILABLE,
    errorMessage: message,
    errorDetail: errorMessage,
  });
  ToastManager.notify({ message: errorMessage });
};

const handleResponse = (responseMsg, responseTypeOk, responseTypeError) => {
  if (responseMsg.type === responseTypeOk) {
    return responseMsg.response;
  }
  if (responseMsg.type === responseTypeError) {
    if (responseMsg?.code === 422 && responseMsg?.type === 'learner.evaluate.get.error') {
      return { evaluationResult: responseMsg };
    }
    const errorMessage = `Socket Error ${responseMsg.code}:${responseMsg.type} - ${responseMsg.message}`;
    // eslint-disable-next-line no-console
    console.error(errorMessage);
    gtmService.pushPageViewEvent({
      errorCode: httpErrorCodes.INTERNAL_SERVER_ERROR,
      errorMessage,
    });
    throw new Error(`${responseMsg.code}:${responseMsg.type} - ${responseMsg.message}`);
  }
  return null;
};
export const fetchFromRTMWithRetries = async (message, responseTypeOk, responseTypeError) => {
  const connection = ConnectionManager.getConnection();
  const responseMsg = await connection.fetchWithRetries(message, {
    onRetry: (retryMessage) => {
      logNewrelicAddPageAction('retrySend', { ...retryMessage, requestType: retryMessage.type });
    },
  });
  return handleResponse(responseMsg, responseTypeOk, responseTypeError);
};
export const fetchFromRTMdedup = async (messageKey, message, responseTypeOk, responseTypeError) => {
  const connection = ConnectionManager.getConnection();
  if (!connection) {
    showConnectionError(message);
  }

  const responseMsg = await connection.fetchDedup(messageKey, message);

  return handleResponse(responseMsg, responseTypeOk, responseTypeError);
};
export const fetchFromRTM = async (message, responseTypeOk, responseTypeError) => {
  const connection = ConnectionManager.getConnection();
  if (!connection) {
    showConnectionError(message);
  }
  const responseMsg = await connection.fetch(message);
  return handleResponse(responseMsg, responseTypeOk, responseTypeError);
};

export const subscribeToRTM = async (message, listener) => {
  const connection = ConnectionManager.getConnection();
  if (!connection) {
    const errorMessage = 'There was a problem communicating with our servers. Try again soon';
    ToastManager.notify({ message: errorMessage });
    gtmService.pushPageViewEvent({
      errorCode: httpErrorCodes.SERVICE_UNAVAILABLE,
      errorMessage,
    });
  }

  try {
    const subscription = await connection.subscribe(message, listener);
    return subscription;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    const errorMessage = 'Unable to subscribe';
    ToastManager.notify({ message: errorMessage });
    gtmService.pushTelemetryPageError(httpErrorCodes.BAD_REQUEST, errorMessage);
  }

  return null;
};
